import React from "react";
import TechnologyPartnerSection from "./TechnologyPartnerSection";
import './TechnologyPartners.css';
export default function TechnologyPartners() {
  return (
    <>
      {/* <UpdatesBanner
        className="partnerbg" bannerText={["Technology Partners"]}
        /> */}

      {/* <NetworkBanner /> */}
      {/* <div className="main-wrapper"> */}
        <TechnologyPartnerSection/>
      {/* </div>
      <FooterComponent /> */}
    </>
  );
}
